import Header from '../Component/Header'
import Footer from '../Component/Footer'
import Breadcrumb from '../Component/Breadcrumb'
const Uniform = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="School Uniform" midBreadcrumb="Rules" mainBreadcrumb="School Uniform" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className="row uniform">
                        <div className="col-12">
                            <h2 className="mainhead">School Uniform</h2>
                            <h3 className="subhead">It’s not about the dress you wear, but the
                                life you lead in the dress</h3>
                            <p>Students must be dressed in prescribed school uniform while
                                attending assembly, class and a school function. It is compulsory for the students to wear the school
                                uniform on all class days, examination days and for all school functions. The uniform must be properly
                                washed and neatly ironed. The shoes must be well polished.</p>
                        </div>
                        <div className="col-md-6 col-12">
                            <h3 className="subhead"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/uniform.png"
                                className="img-fluid" alt="matamariamjansevavidyalayas" />Boys Uniform </h3>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <tbody>
                                        <tr>
                                            <td><strong>I to X</strong></td>
                                            <td>Blue Shirt With Half Sleeve, Navy Blue Pant for classes</td>
                                        </tr>
                                        <tr>
                                            <td><strong>XI and XII</strong></td>
                                            <td>Blue Shirt With FUll Sleeve, Navy Blue Pant for classes</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <h3 className="subhead"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/uniform.png"
                                className="img-fluid" alt="matamariamjansevavidyalayas" />Girls Uniform </h3>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <tbody>
                                        <tr>
                                            <td><strong>I to X</strong></td>
                                            <td>Blue Shirt With Half Sleeve, Navy Blue Skirt for classes</td>
                                        </tr>
                                        <tr>
                                            <td><strong>XI and XII</strong></td>
                                            <td>Blue Shirt With FUll Sleeve, Navy Blue Skirt for classes</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <h3 className="subhead"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/uniform.png"
                                className="img-fluid" alt="matamariamjansevavidyalayas" />KG Uniform</h3>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <tbody>
                                        <tr>
                                            <td><strong>KG Boys </strong></td>
                                            <td>Green shirt with Half Sleeve, Navy Blue Pant</td>
                                        </tr>
                                        <tr>
                                            <td><strong>KG Girls</strong></td>
                                            <td>Green Shirt, Navy Blue Skirt</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-md-6 col-12">
                            <h3 className="subhead"><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/uniform.png"
                                className="img-fluid" alt="matamariamjansevavidyalayas" />Thursday Uniform</h3>
                            <p></p>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered text-center">
                                    <tbody>
                                        <tr>
                                            <td><strong>I to XII</strong></td>
                                            <td>House T-shirt and White Pant</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Kindergarten</strong></td>
                                            <td>White Shirt</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Uniform